import _ from 'lodash';
import moment from 'moment';

function PlannerCtrl($rootScope, $scope, $timeout, $stateParams, toastr, uiCalendarConfig, AuthService, PlanService, UserService, AppContextService, $ngConfirm) {
  'ngInject';

  const vm = this;
  // $rootScope.$emit('base:sidebarEvent', true, false);
  vm.appContext = AppContextService.context;

  var user_id;

  // if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
  //   vm.isLocalhost = true;
  // }




  var date = new Date();
  var d = date.getDate();
  var m = date.getMonth();
  var y = date.getFullYear();

  vm.planData = {
    month: null
  };

  vm.events = [];
  vm.todayEvents = [];

  // var tooltip = $('<div/>').qtip({
  //   id: 'fullcalendar',
  //   prerender: true,
  //   content: {
  //     text: ' ',
  //     title: {
  //       button: true
  //     }
  //   },
  //   position: {
  //     my: 'bottom center',
  //     at: 'top center',
  //     target: 'mouse',
  //     viewport: $('#fullcalendar'),
  //     adjust: {
  //       mouse: false,
  //       scroll: false
  //     }
  //   },
  //   show: false,
  //   hide: false,
  //   style: 'qtip-light'
  // }).qtip('api');

  var tooltip = $('<div/>').qtip({
    id: 'fullcalendar',
    prerender: true,
    content: {
      text: ' ',
      title: {
        button: true
      }
    },
    position: {
      my: 'bottom center',
      at: 'top center',
      target: 'mouse',
      viewport: $('#large-calendar'),
      adjust: {
        mouse: false,
        scroll: false
      }
    },
    show: false,
    hide: false,
    style: 'qtip-light'
  }).qtip('api');

  vm.uiCalendarConfig = {
    theme: false,
    header: {
      // left: 'title prev,next,today',
      center: '',
      // right: 'agendaDay,agendaWeek,month'
    },
    // views: {
    //   agendaDay: {
    //     buttonText: '일간',
    //     columnFormat: 'ddd  M/D'
    //   },
    //   agendaWeek: {
    //     buttonText: '주간',
    //   },
    //   month: {
    //     buttonText: '월간',
    //   },
    // },

    timeFormat: 'HH:mm',
    editable: false,
    selectable: false,
    allDaySlot: false,
    eventLimit: true, // for all non-agenda views
    views: {
      month: {
        eventLimit: 2
      }
    },
    locale: 'ko',
    fixedWeekCount: false,
    viewRender: function (event, element) {

      var date = $('#large-calendar').fullCalendar('getDate');
      $('#mini-calendar').fullCalendar('gotoDate', date.format('YYYY-MM-DD'));
      vm.planData.month = date.format('YYYY.MM');
      vm.selectedDate = null;
      getPlans();

    },
    eventClick: function (event, jsEvent, view) {
      if (event.url.match('notAllowed')) {
        toastr.error('결제 후 사용하실 수 있습니다.');
        return false;
      } else {
        if (event.type === '일정') {
          vm.selectedDate = vm.date = moment(event.start).format('YYYY-MM-DD');
          vm.plansByDate();
        }
      }
    },
    dayClick: function (date, jsEvent, view) {
      vm.selectedDate = vm.date = date.format();
      vm.plansByDate();
    },

    // eventMouseover: function (data, event, view) {
    //   var content = '<h3>' + data.title + '</h3>' +
    //     '<p><b>Start:</b> ' + data.start + '<br />' +
    //     (data.end && '<p><b>End:</b> ' + data.end + '</p>' || '');

    //   tooltip.set({
    //     'content.text': content
    //   })
    //     .reposition(event).show(event);
    // },
    // eventMouseout: function () { tooltip.hide() },
    // eventResizeStart: function () { tooltip.hide() },
    // eventDragStart: function () { tooltip.hide() },
    // viewDisplay: function () { tooltip.hide() },

/*     eventRender: function (event, element) {
      // Add qTip for each event.
      element.qtip({
        content: {
          text: event.tooltip,
          title: {
            text: event.tooltipTitle,
          }
        },
        position: {
          my: "top center",
          at: "bottom center",
          container: false,
          viewport: $(window),
          adjust: {
            //method : 'shift shift',
          }
        },
        style: {
          classes: event.tooltipStyleClass,
          width: 350
        },
        hide: {
          fixed: true,
        }

      }); // end of element.qtip({

      //element.tooltip();
    }, */


    // eventAfterRender: function (event, element) {
    //   $(element).tooltip({
    //     title: event.title,
    //     container: "body"

    //   });
    // },
    // eventMouseover: function (event, jsEvent, view) {
    //   $('.fc-event-inner', this).append('<div id=\"' + event.id + '\" class=\"hover-end\">' + 'aaa' + '</div>');
    // },

    // eventMouseout: function (event, jsEvent, view) {
    //   $('#' + event.id).remove();
    // }
  };

  if (vm.appContext.isMobile) {
    vm.uiCalendarConfig.height = 'auto';
  }

  vm.loginInfo = {
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid
  };

  vm.planData = angular.extend(vm.planData, vm.loginInfo);




  let todayDateObj = new Date();
  vm.displayDate = {
    year: todayDateObj.getFullYear(),
    month: todayDateObj.getMonth() + 1,
    date: todayDateObj.getDate()
  };

  if (vm.displayDate.month < 10) {
    vm.displayDate.month = '0' + vm.displayDate.month;
  }
  if (vm.displayDate.date < 10) {
    vm.displayDate.date = '0' + vm.displayDate.date;
  }

  vm.selectedDateEvents = function () {
    return vm.events;
  };

  vm.isGame = false;
  vm.isTraining = false;


  // 선택한 날짜의 기존일정
  vm.selectedDateEvents = [];

  // 일정 추가
  vm.updateEventData = {
    date: null,
    startHour: '07',
    startMinute: '00',
    endHour: '08',
    endMinute: '00',
    content: 'test'
  };

  vm.date= null;
  vm.startHour= '07';
  vm.startMinute= '00';
  vm.endHour='08';
  vm.endMinute='00';
  vm.content = '';
  if (vm.appContext.isLocalhost) {
    vm.content = 'test';
  }


 // 일정 보기
  var getPlans = function () {

    vm.events = [];
    if (vm.selectedPlayers && vm.selectedPlayers.length > 0) {
      // vm.planData.show_team = $scope.$parent.base.selectPlayerList.join();
      var userId = vm.selectedPlayers.map(player => player.user_id);
      userId = userId.join();
      vm.planData.show_team = userId;
    } else {
      vm.planData.show_team = 'B';
    }

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      month: vm.planData.month
    }

    // 전체관리자가 선택한 team_id
    if ($stateParams.manager_admin_team_id) {
      data.team_id = $stateParams.manager_admin_team_id;
    }
    // 팬이 선택한 team_id
    else if ($stateParams.fan_team_id) {
      data.team_id = $stateParams.fan_team_id;
    }
    // 팬이 선택한 user_id
    else if ($stateParams.fan_user_id) {
      data.user_id = $stateParams.fan_user_id;
      if ($stateParams.fan_user_team_id) {
        data.team_id = $stateParams.fan_user_team_id;
      }
    }
    // 감독-선수 소속팀 관련 수정
    // 감독-선수가 선택한 team_id
    else if ($stateParams.coach_player_team_id) {
      data.team_id = $stateParams.coach_player_team_id;
    }

    console.log('data.month',data.month)
    if (!data.month) {
      return;
    }


    // 권한 체크
    vm.appContext.permissionCheck(vm, 'Service.event').then(
      // 권한이 있는 경우
      function() {
        return true;
      },
      // 권한이 없는 경우
      function() {
        return false;
      })
      .then(function(eventPermission) {

        PlanService.plans(data).then(function (res) {
          // var data = res.data;
          // let plans;
          // if (data.plans_player) {
          //   plans = data.plans_player;
          // } else {
          //   plans = data.plans;
          // }
    
          // console.log('plans2', res.data)
    
          var plans = res.data.plans;

          if ((!$stateParams.team_id || $stateParams.team_id == '0') && !$stateParams.fan_user_team_id) {
            plans = [];
          }

          vm.events = [];
    
          _.forEach(plans, function (item) {
    
            // if (!item.is_manager_schedule && vm.appContext.role2 !== 'player') {
            //   return false;
            //   // continue;
            // }
    
            console.log('item : ', item)

            // 팬으로 로그인하여 후원선수를 선택한 경우 다른 선수가 등록한 일정은 보이지 않도록 처리
            let title;
            let url;
            let users;
            let className;
            let is_manager_schedule;
            let registered_by;
            let m = vm.planData.month;
    // console.log($stateParams.fan_user_name, item.registered_by, $stateParams.fan_user_name === item.registered_by);
            if (item.type === '경기') {
              // className = 'w3-pink fc-planner-game';
              className = 'w3-pink w3-border w3-border-pink';
              // className = 'w3-pink';
              // title = '경기 ' + item.title + ' ' + item.time;
              title = '경기';
              // 등록한 사람 이름이 로그인한 사용자 자신이 아닐 경우 일정 명칭에 등록한 사람 이름을 추가
              if (item.registered_by && vm.appContext.user.name !== item.registered_by) {
                title += ' (' + item.registered_by + ')';
              }

              if (item.stadium_name) {
                title = title + '\n' + item.stadium_name;
              }
              if (item.title) {
                title = title + '\n' + item.title;
              }
              url = eventPermission ? '#!/service/event/' + item.id + '?type_code=game&type_name=경기' : 'notAllowed';
              if ($stateParams.team_id) {
                url += '&team_id=' + $stateParams.team_id;
              }
              if ($stateParams.manager_admin_team_id) {
                url += '&manager_admin_team_id=' + $stateParams.manager_admin_team_id + '&team1_id=' + $stateParams.team1_id + '&team2_id=' + $stateParams.team2_id + '&team3_id=' + $stateParams.team3_id + '&team4_id=' + $stateParams.team4_id;
              }
              if ($stateParams.fan_user_id) {
                url += '&fan_user_id=' + $stateParams.fan_user_id;
                if ($stateParams.fan_user_team_id) {
                  url += '&fan_user_team_id=' + $stateParams.fan_user_team_id;
                }
                if ($stateParams.fan_login_id) {
                  url += '&fan_login_id=' + $stateParams.fan_login_id;
                }
              } else if ($stateParams.fan_team_id) {
                url += '&fan_team_id=' + $stateParams.fan_team_id;
              }
              // 감독-선수 소속팀 관련 수정
              else if ($stateParams.coach_player_team_id) {
                url += '&coach_player_team_id=' + $stateParams.coach_player_team_id;
              }
            } else if (item.type === '훈련') {
              // className = 'w3-blue fc-planner-training';
              className = 'w3-blue';
              // title = '훈련 ' + item.title + ' ' + item.time;
              title = '훈련';
              // 등록한 사람 이름이 로그인한 사용자 자신이 아닐 경우 일정 명칭에 등록한 사람 이름을 추가
              if (item.registered_by && vm.appContext.user.name !== item.registered_by) {
                title += ' (' + item.registered_by + ')';
              }

              if (item.stadium_name) {
                title = title + '\n' + item.stadium_name;
              }
              if (item.title) {
                title = title + '\n' + item.title;
              }
              url = eventPermission ? '#!/service/event/' + item.id + '?type_code=training&type_name=훈련' : 'notAllowed';
              if ($stateParams.team_id) {
                url += '&team_id=' + $stateParams.team_id;
              }
              if ($stateParams.manager_admin_team_id) {
                url += '&manager_admin_team_id=' + $stateParams.manager_admin_team_id + '&team1_id=' + $stateParams.team1_id + '&team2_id=' + $stateParams.team2_id + '&team3_id=' + $stateParams.team3_id + '&team4_id=' + $stateParams.team4_id;
              }
              if ($stateParams.fan_user_id) {
                url += '&fan_user_id=' + $stateParams.fan_user_id;
                if ($stateParams.fan_user_team_id) {
                  url += '&fan_user_team_id=' + $stateParams.fan_user_team_id;
                }
                if ($stateParams.fan_login_id) {
                  url += '&fan_login_id=' + $stateParams.fan_login_id;
                }
              } else if ($stateParams.fan_team_id) {
                url += '&fan_team_id=' + $stateParams.fan_team_id;
              }
              // 감독-선수 소속팀 관련 수정
              else if ($stateParams.coach_player_team_id) {
                url += '&coach_player_team_id=' + $stateParams.coach_player_team_id;
              }
            } else if (item.type === '일정') {
              if (item.is_manager_schedule) {
                className = 'fc-planner-plan w3-green';
              } else {
                className = 'fc-planner-plan w3-yellow';            
              }
              console.log('item....', item)
              title = item.title;
              console.log('users.... ', item.users);
              url = '';
              users = _.map(item.users, 'user_name').join();
              is_manager_schedule = item.is_manager_schedule;
            }
            let event = {
              id: item.id,
              title: title,
              url: url,
              registered_by: item.registered_by,
              start: new Date(m.substr(0, 4), parseInt(m.substr(5, 2)) - 1, parseInt(item.day), item.time.substr(0, 2), item.time.substr(3, 2)),
              end: new Date(m.substr(0, 4), parseInt(m.substr(5, 2)) - 1, parseInt(item.day), parseInt(item.time.substr(0, 2)) + 1, item.time.substr(3, 2)),
              className: className,
              is_manager_schedule: is_manager_schedule,
              users : users,
              type: item.type
            };
    
            // $scope.$apply(function () {
            //   // vm.events;
            // })

            // 일정이면서 등록한 사람 이름이 로그인한 사용자 자신이 아닐 경우 일정 명칭에 등록한 사람 이름을 추가
            if (item.type === '일정' && (item.registered_by && vm.appContext.user.name !== item.registered_by)) {
              event.title += ' (' + item.registered_by + ')';
            }
    
            if ( !(item.type === '일정' && !item.is_manager_schedule && vm.appContext.role2 !== 'player') ) {
              vm.events.push(event);
            }
    
    
          });
          vm.plansByDate();
          $('#large-calendar').fullCalendar('removeEvents');
          $('#large-calendar').fullCalendar('addEventSource', vm.events);
        })
          .catch(function (e) {
            console.log('ERROR', e);
          });

      })
      .catch(function(err) {
        console.log(err);
      });

  };
  // getPlans();

  // 일정 등록/수정
  vm.updateEvent = function () {

      // $scope.$watch('vm.appContext.players.all', function (newVal, oldVal) {
  //   if (newVal) {
  //     //console.log(_.map(_.filter(newVal, 'selected'), 'user_id').join());
  //     
  //     getPlans();
  //   }
  // }, true)

    var user_id = _.map(_.filter(vm.appContext.players.all, 'selected'), 'user_id').join();
    // console.log('vm.appContext.players.all', vm.appContext.players.all)
    // console.log('user_id', user_id);

    if (!vm.date) {
      toastr.error('날짜를 선택해주십시오');
      return;
    }


    if (!user_id && vm.eventType === 'schedule') {
      toastr.error('선수를 선택해주십시오');
      return;
    }


    if (vm.eventType === 'schedule' && !vm.content) {
      toastr.error('내용을 입력해주십시오');
      return;
    }

    if (!vm.startHour || !vm.startMinute || !vm.endHour || !vm.endMinute) {
      toastr.error('시작과 종료 시각을 입력해주십시오');
      return;
    }

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      date: (angular.copy(vm.date)).replace(/-/g, '.'),
      time: vm.startHour + ':' + vm.startMinute + ':00',
      end_time: vm.endHour + ':' + vm.endMinute + ':00',
      cts: vm.content,
    }

    if (vm.appContext.role2 !== 'player') {
      data.user_id = user_id;
    }

    // // // console.log(vm.appContext.user);
    // console.log('type, data', vm.eventType, data);
    // return; 

    if (vm.eventType === 'schedule') {
      PlanService.setSchedule(data).then(function (res) {
        getPlans();

        if (vm.appContext.role2 !== 'player') {
          _.map(vm.appContext.players.all, function (x) {
            x.selected = false;
            return x
          });
        }

        if (!isLocalhost) {
          vm.content = '';
        }

      });
    } else {

      var functionName = vm.eventType == 'game' ? 'setGame' : 'setTrainingRoot';

      // var data = {
      //   login_id: vm.appContext.user.login_id,
      //   uuid: vm.appContext.user.uuid,
      //   date: date,
      //   time: time
      // };


      PlanService[functionName](data)
        .then(function (res) {
          getPlans();

          if (vm.appContext.role2 !== 'player') {
            _.map(vm.appContext.players.all, function (x) {
              x.selected = false;
              return x
            });
          }

        })
        .catch(function (error) {
          console.log("An error occured : " + error);
        })

    }

  };

  // 일정 삭제
  vm.deleteEvent = function (event) {



    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            let removeScheduleData = {
              login_id: vm.loginInfo.login_id,
              uuid: vm.loginInfo.uuid,
              schedule_id: event.id
            };

            PlanService.removeSchedule(removeScheduleData).then(function (res) {
              var data = res.data;

              if (data.result === 'SUC') {
                toastr.success('삭제되었습니다.');

                getPlans();

              }
            });


          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
          // action: function (scope, button) {
          // }
        },
      }
    });







  };

  vm.plansByDate = function () {

    vm.selectedDateEvents = [];

    console.log('vm.events', vm.events);

    for (var i = 0; i < vm.events.length; i++) {
      
      var startDateObj = vm.events[i].start;
      var year = startDateObj.getFullYear(),
        month = startDateObj.getMonth() + 1,
        day = startDateObj.getDate();

      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }

      var s = year + '-' + month + '-' + day;
      if (s === vm.selectedDate) {
        vm.selectedDateEvents.push(vm.events[i]);
        // $scope.$apply(function () {
        // })
      }
    }
  };

  vm.selectPlayerAll = function (choice) {
    $scope.$parent.base.selectPlayerAll(choice);
  };

  $scope.$on('playerToggle', function () {
    // getPlans();
  });

  $scope.$on('playerSelectAll', function () {
    // getPlans();
  });





}

export default {
  name: 'PlannerCtrl',
  fn: PlannerCtrl
};
